if (!customElements.get('kn-newsletter')) {
  customElements.define('kn-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.listeners = new AbortController();
      const signal = this.listeners.signal;
      const form = this.querySelector('form');
      const email = form.querySelector('input[type="email"]');
      const message = this.querySelector('.kf-msg');
      const button = form.querySelector('button[type="submit"]');
      this.dialog = this.querySelector('.kf-confirmation');
      const resetPending = () => {
        clearTimeout(this.pendingTimer);
        form.removeAttribute('aria-busy');
        button.disabled = false;
        button.removeAttribute('aria-label');
      };
      this.addEventListener('pointerdown', () => { this.dataset.inputMode = 'pointer'; }, { signal });
      document.addEventListener('keydown', (event) => {
        if (['Tab', 'Enter', ' ', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
          this.dataset.inputMode = 'keyboard';
        }
      }, { signal });
      form.noValidate = true;
      email.addEventListener('input', () => {
        resetPending();
        message.textContent = '';
        message.classList.remove('err', 'ok');
        email.removeAttribute('aria-invalid');
      }, { signal });
      form.addEventListener('submit', (event) => {
        email.value = email.value.trim();
        if (!email.value || !email.validity.valid || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) {
          event.preventDefault();
          message.textContent = email.value
            ? 'Enter a valid email address, like name@example.com.'
            : 'Enter your email address.';
          message.classList.remove('ok');
          message.classList.add('err');
          email.setAttribute('aria-invalid', 'true');
          email.focus();
          return;
        }
        clearTimeout(this.pendingTimer);
        message.textContent = '';
        message.classList.remove('err', 'ok');
        email.removeAttribute('aria-invalid');
        form.setAttribute('aria-busy', 'true');
        button.disabled = true;
        button.setAttribute('aria-label', 'Submitting your email');
        // Restore retry controls if verification is cancelled or the connection stalls.
        this.pendingTimer = setTimeout(() => {
          if (!this.isConnected) return;
          resetPending();
          message.textContent = 'Complete any verification shown, then try again if needed.';
        }, 20000);
      }, { signal });
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) resetPending();
      }, { signal });
      if (message.classList.contains('err') && message.hasAttribute('data-newsletter-result')) {
        email.focus({ preventScroll: true });
      }
    }

    disconnectedCallback() {
      this.listeners?.abort();
      clearTimeout(this.pendingTimer);
      if (this.dialog?.open) this.dialog.close();
      this.dialog?.restoreNewsletterPage?.();
    }
  });
}
